export enum MemberTransferStepEnum {
    PersonalDetails = 'Personal details',
    PostalAddress = 'Postal address',
    Location = 'Country of practice',
    TransferInformation = 'Transfer information',
    SupportingDocuments = 'Supporting documents',
    DeclarationAndPetition = 'Declaration and petition'
}